









































































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import ElImageViewer from '@/components/imageviewer.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import collapse from '../../utils/collapse.js';
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import { upload } from '../../common/util/ossUploadService';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { yun, CspInquiry } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        ElImageViewer,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
    },
})
export default class carManager extends Vue {
    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public handleClose() {
        this.dialogVisible = false;
        this.drivingLicenseImgs = [];
        this.roadTransportCertificateImgs = [];
        this.businessLicenseImgs = [];
    }


    public searchValue: any = {
         carCode: '',
         driverName: '',
         carLength: '',
         carType:'',
         enabled: true,
         carrierId: '',
         carrierName: '',
         syncStatus: '',
         orderBy: '',
         asc: true,
    };

    public timeList = [];

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('carManager', JSON.stringify(this.colData));
    }
    public colData = JSON.parse(localStorage.getItem('carManager'))
        ? JSON.parse(localStorage.getItem('carManager'))
        : [
              { title: '车牌号', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '主驾驶员', isShow: true, disabled: false },
              { title: '车辆类型', isShow: true, disabled: false },
              { title: '轴数', isShow: true, disabled: false },
              { title: '车辆自重KG', isShow: true, disabled: false },
              { title: '车辆长度', isShow: true, disabled: false },
              { title: '是否马鞍山', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
              { title: '同步状态', isShow: true, disabled: false },
              { title: '同步时间', isShow: true, disabled: false },
          ];

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        pagination1: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        updateEnabledForm:HTMLFormElement
    };

    public searchFunc() {
        sessionStorage.setItem('carManager_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
 
    public resetSearchValue() {
        this.searchValue = {
            carCode: '',
            driverName: '',
            carLength: '',
            carType:'',
            enabled: true,
        carrierId: '',
            carrierName: '',
            syncStatus: '',
            orderBy: '',
            asc: true,
        };
        this.carLengths = [];
        this.searchFunc();
    }

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await yun.GetCarList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }

    public created() {
     
    }
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public async getdd() {
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'carType' });
    }
    public mounted() {
        this.getdd();
        if (sessionStorage.getItem('carManager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('carManager_searchValue'));
            this.searchPagin = sessionStorage.getItem('carManager_page') ? JSON.parse(sessionStorage.getItem('carManager_page')) : this.searchPagin;
            if (this.searchValue.carLength) {
                this.carLengths = this.searchValue.carLength.split(',');
            }
            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('carManager_page') ? JSON.parse(sessionStorage.getItem('carManager_page')) : this.searchPagin;

            this.loadData();
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('carManager_page', JSON.stringify(pagin));
        this.loadData();
    }

    public formData: any = {
      
    };
    drivingLicenseImgs: any = [];
    roadTransportCertificateImgs: any = [];
    businessLicenseImgs: any = [];

    public title = '新增车辆';


    public async toEdit(id) {
        this.title = '车辆详情';
        this.drivingLicenseImgs = [];
        this.roadTransportCertificateImgs = [];
        this.businessLicenseImgs = [];
        this.formData = {
        };
        let res = await yun.GetDetai1(id);
        console.log('ress', res);
        if (res.drivingLicenseImg) {
            this.drivingLicenseImgs.push({
                name: 'drivingLicenseImg',
                url: res.drivingLicenseImg,
            });
        }
        if (res.roadTransportCertificateImg) {
            this.roadTransportCertificateImgs.push({
                name: 'roadTransportCertificateImg',
                url: res.roadTransportCertificateImg,
            });
        }
        if (res.businessLicenseImg) {
            this.businessLicenseImgs.push({
                name: 'businessLicenseImg',
                url: res.businessLicenseImg,
            });
        }
        Object.keys(res).forEach((key) => {
            this.formData[key] = res[key];
        });

        // this.$refs.formData.resetFields();
        this.dialogVisible = true;
    }



    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    public carTypeChange(item) {
        //this.form.platformCompanyId = item.code
        console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData.carType = data.name;
        });
    }
    public carLengths = [];
    public carLengthChange(item) {
        //this.form.platformCompanyId = item.code
        this.searchValue.carLength = '';
        this.carLengths.forEach((data, index) => {
            if (index > 0) {
                this.searchValue.carLength = this.searchValue.carLength + ',' + data;
            } else {
                this.searchValue.carLength = data;
            }
        });
        this.carLengthList.forEach((data) => {
            if (data.value == item) this.formData.carLength = data.name;
        });
    }
    urls: any = [];
    showViewer: any = false;
    closeViewer() {
        this.showViewer = false;
    }
    dialogImageUrl = '';
    dialogImage: any = false;
    public handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImage = true;
    }
    public onClose() {
        this.dialogImage = false;
    }
    cc;
    store;
    async handleUpload1(param, data) {
        this.cc = data;
        console.log('123', param, data);
        let res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            var imageUrl = res.res.requestUrls[0].split('?')[0];
            this.$set(this.formData, data + '', imageUrl);
            console.log('12344', this.formData);
        } else {
            this.$alert(`上传失败，请重新上传`);
        }
    }
    handleRemove1(param, data) {
        console.log('datas', data, this.formData);
        this.$set(this.formData, data + '', '');
    }

    async updateImage(e: any) {
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let res = await yun.DriverImportCars(param);
        if (res) {
            this.$emit('updateSearch');
            this.$message.success('导入成功!');
        } else {
            this.$message.error('导入失败!');
        }
    }
    public selectDirver: any = {};

    public carName = '';

    public carrierName = '';
    selectList = [];
    selectCar1(data) {
        this.searchValue.carrierId = data.id;
    }
    async querySearch1(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'carCode':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'carLength':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
                 case 'creationTime':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
                 case 'driverName':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
        }
        this.loadData();
    }
    public async exportExcel() {
        let res = await yun.CarExport({ ...this.searchValue });
    }
    public dialogConfig: boolean = false;
    public disableReasonDialog: boolean = false;
    confirmClose(){
        this.dialogConfig = false;
    }
    public updateEnabledForm = {
        carCode:'',
        enabled:null,
        disableReason: ''
    }
    disableReasonConfirm(){
        let data = this.updateEnabledForm;
          if(data.enabled){
              this.$refs.updateEnabledForm.validate(async (valid) => {
               if(valid){
                  yun.CarEnable({carCode:data.carCode,enabled:!data.enabled,disableReason:data.disableReason}).then(res=>{
                  this.$message.success('禁用成功');
                    this.disableReasonDialog = false;
                    this.loadData()
                })  
               }
            })
          }else{
             yun.CarEnable({carCode:data.carCode,enabled:!data.enabled,disableReason:data.disableReason}).then(res=>{
                this.$message.success('启用成功');
                    this.dialogConfig = false;
                    this.loadData();
            }) 
          }
    }
    updateEnabled(data){
        this.updateEnabledForm = {
            carCode:data.carCode,
            enabled:data.enabled,
            disableReason: ''
        }
        if(data.enabled){
             this.disableReasonDialog = true;
              this.$refs.updateEnabledForm.resetFields();
        }else{
             this.dialogConfig = true;
        }
    }

    public dialogConfig2: any = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public carId:string = '';
    public sync(id){
        this.carId = id;
        this.dialogConfig2 = {
            title: '同步该车辆至山鹰TMS系统',
            show: true,
        };
    }
    async confirmOk() {
        yun.PushCarToTms(this.carId).then(() => {
            this.$message.success('操作成功');
            this.loadData();
        });
        this.dialogConfig2 = {
            show: false,
        };
    }
}
